import React, { useEffect, useMemo, useRef, useState } from 'react'
import SrpSmBox from './SrpSmBox';
import SrpMdBox from './SrpMdBox';


const SrpList = ({ filteredVehicleData, numberFormatter, priceFormatter }) => {

    /*const sortedVehicles = useMemo(() => {
        let temp = filteredVehicleData && filteredVehicleData.sort((a,b) => (a.vehicle_type == "recently sold") - (b.vehicle_type == "recently sold"));

        let vehicles = [];

        temp.forEach((vehicle,i) => {

        })


    },[])*/

    //const [featuredVehicles,setFeaturedVehicles] = useState([]);

    let adjustedIndex = 0;

    let featuredVehicles = filteredVehicleData.filter(v => v?.inventory_manage.lease_special == 1);

    /*useEffect(() => {
        if(filteredVehicleData) setFeaturedVehicles(filteredVehicleData.filter(v => v?.inventory_manage.lease_special == 1));
        

        console.log(filteredVehicleData.filter(v => v?.inventory_manage.lease_special == 1));

    },[filteredVehicleData]);*/

    return (
        <>
            <section className='srp-list-wrap'>
                <div className='container'>
                    <div className='srp-block'>
                        <div className='row'>
                            {/* {filteredVehicleData && filteredVehicleData.map((item, index, array) =>
                            <React.Fragment key={index}>
                                {item.inventory_manage.lease_special ?
                                    <SrpMdBox
                                        item={item}
                                        index={index}
                                        numberFormatter={numberFormatter}
                                    
                                    /> : 
                                    <SrpSmBox
                                        item={item}
                                        index={index}
                                        numberFormatter={numberFormatter}
                                    />
                                }
                                
                            </React.Fragment>
                        )} */}
                            {filteredVehicleData && filteredVehicleData.sort((a,b) => (a.vehicle_type == "recently sold") - (b.vehicle_type == "recently sold")).map((item, index, array) => {

                                var thisFeatured = null;

                                if(adjustedIndex > 0 && featuredVehicles.length > 0 && adjustedIndex > 0 && adjustedIndex % 3 == 0) {
                                    thisFeatured = featuredVehicles.shift();

                                    adjustedIndex += 2;
                                }

                                adjustedIndex++;

                                return (
                                    <React.Fragment key={item.vin}>
                                        {/* After the 6th item, insert InventoryMdBox index === 5 && latestDrop */}
                                        {thisFeatured && 
                                            <SrpMdBox
                                                item={thisFeatured}
                                                index={index}
                                                numberFormatter={numberFormatter}
                                                priceFormatter={priceFormatter}
                                            />
                                        }
                                        <SrpSmBox
                                            item={item}
                                            index={index}
                                            numberFormatter={numberFormatter}
                                            priceFormatter={priceFormatter}
                                        />
                                    </React.Fragment>
                                );
                                /*const adjustedIndex = index + 1;
                                if (item?.inventory_manage.lease_special && adjustedIndex % 3 === 0) {
                                    return (
                                        <React.Fragment key={index}>
                                            <SrpSmBox
                                                item={item}
                                                index={index}
                                                numberFormatter={numberFormatter}
                                                priceFormatter={priceFormatter}
                                            />
                                            {adjustedIndex < array.length && (
                                                <SrpMdBox
                                                    item={item}
                                                    index={index}
                                                    numberFormatter={numberFormatter}
                                                    priceFormatter={priceFormatter}
                                                />
                                            )}
                                        </React.Fragment>
                                    );
                                } 
                                else if ((adjustedIndex - 1) % 3 === 0 && array[adjustedIndex - 2]?.latest_drop) {
                                    return null;
                                } 
                                else {
                                    return (
                                        <React.Fragment key={index}>
                                            {item?.inventory_manage.lease_special ? (
                                                <SrpMdBox
                                                    item={item}
                                                    index={index}
                                                    numberFormatter={numberFormatter}
                                                    priceFormatter={priceFormatter}
                                                    adjustedIndex={adjustedIndex}
                                                />
                                            ) : (
                                                <SrpSmBox
                                                    item={item}
                                                    index={index}
                                                    numberFormatter={numberFormatter}
                                                    priceFormatter={priceFormatter}
                                                />
                                            )}
                                        </React.Fragment>
                                    );
                                }*/
                            })}
                            {featuredVehicles.map((item, index) => (
                                <SrpMdBox
                                    item={item}
                                    index={index}
                                    numberFormatter={numberFormatter}
                                    priceFormatter={priceFormatter}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SrpList